'use strict';

/**
 * !! Important Note
 * If your project required to work with IE11.
 * Please add `ie11` to `supportTarget` in `node_scripts/config.js`
 * In this way, ESBuild will use babel to transform script to ES5 before compile.
 *
 * !! Please note that ESBuild still do not support ES6 `let` statement declares.
 */

/**
 * @typedef {import('jquery')} jQuery
 * @typedef {import('jquery')} $
 */
import './security';
import './_frontend/sections';
import './_frontend/components';
import './_frontend/override';

// Initial
// ===============================================================

document.addEventListener('DOMContentLoaded', function () {
  jQuery(function () {
    jQuery.isMobileView = function () {
      return [null, 'sm', 'md'].indexOf($.gridSize()) >= 0;
    };
    jQuery.isTabletView = function () {
      return ['sm', 'md'].indexOf($.gridSize()) >= 0;
    };
    jQuery.extend({
      gridSize: function () {
        var envs = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'],
          $el = $('<div>');
        $el.appendTo($('body'));
        for (var i = envs.length - 1; i >= 0; i--) {
          var env = envs[i];
          $el.addClass('d-' + env + '-none');
          if ($el.is(':hidden')) {
            $el.remove();
            return env;
          }
        }
        $el.remove();
        return null;
      }
    });
  });
  setTimeout(function () {
    $('html').addClass('initial');

    // if cookie `one-time-animation` not exist
    // Add cookie to mark that one-time-animation has been played, which will expire in 1 day
    if (document.cookie.indexOf('one-time-animation=played') === -1) {
      document.cookie = 'one-time-animation=played; path=/; max-age=' + 60 * 60 * 24;
    }
  }, 500);

  // listern to window scroll event, monitior all sections.
  // when a section scroll into screen, add class 'visible' to it, and remove class 'visible' on leaving screen
  $(window).on('scroll', function () {
    var $sections = $('section');
    $sections.each(function () {
      var $section = $(this),
        sectionTop = $section.offset().top,
        sectionHeight = $section.outerHeight(),
        sectionBottom = sectionTop + sectionHeight,
        windowTop = $(window).scrollTop(),
        windowBottom = windowTop + window.innerHeight;
      if (windowTop < sectionBottom && windowBottom > sectionTop) {
        $section.addClass('visible visible-once').trigger('enter-screen');
      } else {
        $section.removeClass('visible').trigger('leave-screen');
      }
    });
  });
  $('body').on('click', '[data-href]', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var url = $(this).data('href'),
      target = $(this).data('target') ?? '_self';
    if (target !== '_self') {
      window.open(url, target);
    } else {
      location.href = url;
    }
  }).on('click', '[data-href] a', function (e) {
    e.stopPropagation();
  });
});